module.exports = __webpack_public_path__ + "img/gift5-02-c1.65c2086e.png";